import React from 'react';
import { motion } from 'framer-motion';
import { LeadForm } from './LeadForm';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-192">
      {/* Background Gradient */}
      <div className="absolute inset-0 z-0" data-id="element-193">
        <div className="absolute inset-0 bg-gradient-to-br from-navy via-steel to-indigo opacity-95" data-id="element-194"></div>
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-195"></div>

        {/* Animated blobs */}
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-indigo rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-196"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-primary rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" data-id="element-197"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-198">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-199">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="lg:col-span-7 text-white" data-id="element-200">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-201">
              Asesoría integral para{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-200" data-id="element-202">
                empresas y particulares
              </span>{' '}
              en España
            </h1>

            <p className="text-lg md:text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed" data-id="element-203">
              Lideramos su aterrizaje, blindamos su fiscalidad y gobernamos su
              contabilidad. En NETCG & ASOCIADOS despejamos el camino para que
              su capital y talento operen con absoluta libertad en España.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-204">
              <Button variant="primary" size="lg" className="w-full sm:w-auto text-lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-205">
                Agendar llamada
              </Button>
              <Button variant="secondary" size="lg" className="w-full sm:w-auto text-lg" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-207" />} onClick={scrollToServices} data-id="element-206">
                Ver servicios
              </Button>
            </div>

            {/* Trust Bullets */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 border-t border-white/10 pt-8" data-id="element-208">
              {['Respuesta en 24-48h', 'Gestión 360° de visados', 'Acompañamiento total'].map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-209">
                  <div className="p-1 rounded-full bg-green-500/20 text-green-400" data-id="element-210">
                    <CheckCircle2 className="w-5 h-5" data-id="element-211" />
                  </div>
                  <span className="text-sm font-medium text-gray-200" data-id="element-212">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>

          {/* Form Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="lg:col-span-5" data-id="element-213">
            <LeadForm variant="hero" data-id="element-214" />
          </motion.div>
        </div>
      </div>
    </section>;
}